import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule} from '@angular/forms';
 import {ProvidersService} from '../../providers/providers.service';
import {ReservationService} from '../reservations.service';
import { ReservationChangeProviderComponent } from './reservation-change-provider.component';
import { DropdownProviderModule } from 'app/utils/dropdown-provider/dropdown-provider.module';
import { MyDateRangePickerModule } from 'mydaterangepicker';
import { DateRangeAvailableUpdateSoModule } from 'app/utils/date-range-available-update-so/date-range-available-update-so.module';

@NgModule({
  imports: [
    CommonModule,
      FormsModule,
      DropdownProviderModule,
      MyDateRangePickerModule,
      DateRangeAvailableUpdateSoModule
  ],
  declarations: [ ReservationChangeProviderComponent ],
    providers: [
        ReservationService,
        ProvidersService
    ],
    exports: [
        ReservationChangeProviderComponent
     ]
})
export class ReservationChangeProviderModule { }



// WEBPACK FOOTER //
// ./src/app/pages/trip-reservations/reservation-change-provider/reservation-change-provider.module.ts